//================================================================
//  Component: Dynamic Vendor Rating
//================================================================

//  Purpose: This is the dynamic vendor rating

//  Properties:
//    - letter = {A string, this is the UpGuard grade for the vendor}

//  Example:
//    <DynamicVendorRating
//      letter={vendor?.securitygrade}
//      score={vendor?.securityscore}
//      lastmodifieddate={vendor?.lastmodifieddate}
//    ></DynamicVendorRating>    

//================================================================

//Libraries
import React from 'react';

// Images
import A from '../Images/Icon_Info_DarkGreen.svg';
import B from '../Images/Icon_Info_LightGreen.svg';
import C from '../Images/Icon_Info_Yellow.svg';
import D from '../Images/Icon_Info_Orange.svg';
import F from '../Images/Icon_Info_Red.svg';
import NA from '../Images/Icon_Info_Grey.svg';
import ConvertDate from '../../Library/ConvertDate';


export default function DynamicVendorRating({ letter, score, lastmodifieddate }) {

    //------------------------------------------------------
    //  Define Variables
    //------------------------------------------------------

    // Handle undefined values by converting them to 'N/A'
    const isRatingAvailable = letter && score;
    const displayLetter = letter || 'N/A';
    const displayScore = score || 'N/A';

    // Constants for vendor rating styling using Tailwind classes
    const vendorRatingConfig = {
        'A': {
            textColor: 'text-[#07A64A]',
            borderColor: 'border-[#07A64A]',
            backgroundColor: 'bg-[#F4FBF7]',
            image: A
        },
        'B': {
            textColor: 'text-[#95D034]',
            borderColor: 'border-[#95D034]',
            backgroundColor: 'bg-[#FAFCF5]',
            image: B
        },
        'C': {
            textColor: 'text-[#E8B61A]',
            borderColor: 'border-[#E8B61A]',
            backgroundColor: 'bg-[#FEFCF3]',
            image: C
        },
        'D': {
            textColor: 'text-[#FF6800]',
            borderColor: 'border-[#FF6800]',
            backgroundColor: 'bg-[#FFF8F2]',
            image: D
        },
        'F': {
            textColor: 'text-[#EE1200]',
            borderColor: 'border-[#EE1200]',
            backgroundColor: 'bg-[#FEF5F5]',
            image: F
        },
        'N/A': {
            textColor: 'text-[#424242]',
            borderColor: 'border-[#616161]',
            backgroundColor: 'bg-[#F5F5F5]',
            image: NA
        }
    };


    // Get the config for the current letter, defaulting to N/A if not found
    const currentConfig = vendorRatingConfig[displayLetter] || vendorRatingConfig['N/A'];

    //------------------------------------------------------
    //  HTML
    //------------------------------------------------------

    return (
        <div>
            <div className={`flex gap-2 rounded-lg px-[15px] py-[7px] mx-1 my-1 border-[1.5px] w-[450px] ${currentConfig.borderColor} ${currentConfig.backgroundColor}`}>
                <img src={currentConfig.image} alt='Info icon' width={25} height={25} />
                <p className={`mb-0 text-[#424242]`}>
                    Vendor risk rating:
                    <b className='font-semibold'>
                        {
                            isRatingAvailable ?
                                ` ${displayLetter} - ${displayScore}`
                                :
                                ' Not Available'
                        }
                    </b>
                </p>

            </div>
            {
                lastmodifieddate !== '' ?
                    <p className='text-gray-500 ml-1 mb-0 text-[14px]'>Last updated: { lastmodifieddate === undefined ? '-' : ConvertDate(lastmodifieddate)}</p>
                    : null
            }
        </div>
    );

}
